import {
  GraduationCap, Handshake, MessageCircle, Users, UserX, ClipboardCheck,
  Briefcase, Play, BookOpen, UserCheck, Search, Brain, BarChart3, HelpCircle, Headphones,
  Home, Target, Mic, CheckSquare, Map, Bookmark, Sparkles, CheckCircle,
} from "lucide-react";
import DashboardIcon from "../../images/icons/dashboard-icon.png";
import Mentors from "../../images/icons/mentors.png";
import Community from "../../images/icons/community.png";
import complains from "../../images/icons/complain-icon.png";
import CalenderSvg from "../../images/svgs/CalenderSvg";
import ChatIconOne from "../../images/svgs/ChatIconOne";
import Mingcutetimeline from "../../images/svgs/Mingcutetimeline";
import Profile from "../../images/svgs/Profile";
import ReportIcon from "../../images/svgs/ReportIcon";
import Star from "../../images/svgs/Star";

export const menuItems = {
  home: { name: "Home", icon: Home, link: "/dashboard/home-new" },
  welcome: { name: "Welcome", icon: Sparkles, link: "/dashboard/welcome" },
  dashboard: { name: "Dashboard", icon: DashboardIcon, link: "/dashboard/home" },
  aiJobImpactAssessment: { name: "AI Job Impact Assessment", icon: BarChart3, link: "/dashboard/career-assessment/ai-job-impact-assessment" },
  aiLiteracyAssessment: { name: "AI Literacy Assessment", icon: Brain, link: "/dashboard/career-assessment/ai-literacy-assessment" },
  careerRecommendations: { name: "Career Recommendations", icon: Briefcase, link: "/dashboard/career-discovery/career-recommendations" },
  careerSimulationTool: { name: "Career Simulation Tool", icon: Play, link: "/dashboard/career-discovery/career-simulation-tool" },
  mySavedCareers: { name: "My Saved Careers", icon: Bookmark, link: "/dashboard/career-discovery/my-saved-careers" },
  mySimulations: { name: "My Simulations", icon: BarChart3, link: "/dashboard/career-discovery/my-simulations" },
  skillsGapAnalysisTool: { name: "Skills Gap Analysis Tool", icon: GraduationCap, link: "/dashboard/skills-and-learning/skill-gap-analysis-tool" },
  myUpskillingPathway: { name: "My Upskilling Pathway", icon: Target, link: "/dashboard/skills-and-learning/upskilling-pathway-config" },
  mySmartLearningHelper: { name: "My Smart Learning Helper", icon: Map, link: "/dashboard/skills-and-learning/my-smart-learning-helper" },
  allCourses: { name: "All Courses", icon: BookOpen, link: "/dashboard/skills-and-learning/all-courses?courseTab=ontrack-courses" },
  mentorship: { name: "Mentorship", icon: Users, link: "/dashboard/mentors-and-community/mentorship" },
  myMentors: { name: "My Mentors", icon: ChatIconOne, link: "/dashboard/chats-with-mentors" },
  community: { name: "Community", icon: MessageCircle, link: "/dashboard/mentors-and-community/community" },
  jobs: { name: "Jobs", icon: Search, link: "/dashboard/job-support/jobs" },
  savedJobs: { name: "Saved Jobs", icon: Bookmark, link: "/dashboard/job-support/saved-jobs" },
  aiTalentPool: { name: "AI Talent Pool", icon: UserCheck, link: "/dashboard/job-support/ai-talent-pool" },
  mockInterviewPractice: { name: "Mock Interview Practice", icon: Mic, link: "/dashboard/job-support/mock-interview" },
};

// Help & Support section - used by the main Sidebar component
export const helpSupportList = [
  { name: "FAQ", icon: HelpCircle, link: "/dashboard/help-and-support/faq" },
  { name: "Help us Improve", icon: Brain, link: "/dashboard/help-and-support/help-us-improve" },
  { name: "Update Subscription", icon: BarChart3, link: "/dashboard/help-and-support/update-subscription" },
  { name: "Support", icon: Headphones, link: "/dashboard/help-and-support/support" },
];

// Main sidebar categories - used by the main Sidebar component
export const sidebarCategories = [
  { name: "Welcome", icon: Sparkles, items: [menuItems.welcome] },
  { name: "Home", icon: Home, items: [menuItems.home] },
  { name: "Career Assessments", icon: CheckSquare, items: [menuItems.aiJobImpactAssessment, menuItems.aiLiteracyAssessment] },
  { name: "Career Discovery", icon: Target, items: [menuItems.careerRecommendations, menuItems.careerSimulationTool, menuItems.mySavedCareers, menuItems.mySimulations] },
  { name: "Skills and Learning", icon: GraduationCap, items: [menuItems.skillsGapAnalysisTool, menuItems.myUpskillingPathway, menuItems.mySmartLearningHelper, menuItems.allCourses] },
  { name: "Mentors & Community", icon: Users, items: [menuItems.mentorship, menuItems.myMentors, menuItems.community] },
  { name: "Job Support", icon: Search, items: [menuItems.jobs, menuItems.savedJobs, menuItems.aiTalentPool, menuItems.mockInterviewPractice] }
];

// Legacy exports - kept for backward compatibility but not used by main Sidebar
export const sideBarList = [
  { name: "Home", icon: Briefcase, link: "/dashboard/home" },
  { name: "Welcome", icon: Sparkles, link: "/dashboard/welcome" },
  { name: "Career Recommendations", icon: Briefcase, link: "/dashboard/career-discovery/career-recommendations" },
  { name: "AI Job Impact Assessment", icon: ClipboardCheck, link: "/dashboard/career-assessment/ai-job-impact-assessment" },
  { name: "AI Literacy Assessment", icon: GraduationCap, link: "/dashboard/career-assessment/ai-literacy-assessment" },
  { name: "Skill Gap Analysis", icon: Search, link: "/dashboard/skill-gap-analysis-tool" },
  { name: "AI Skills and Learning Interests", icon: Brain, link: "/dashboard/ai-skills-learning" },
  { name: "My Smart Learning Helper", icon: BookOpen, link: "/dashboard/learning-pathway/smart-learning-helper" },
  { name: "All Courses", icon: GraduationCap, link: "/dashboard/skills-and-learning/all-courses?courseTab=ontrack-courses" },
  { name: "AI Talent Pool", icon: UserCheck, link: "/dashboard/job-support/ai-talent-pool" },
  { name: "Jobs", icon: ClipboardCheck, link: "/dashboard/job-support/jobs" },
  { name: "Mentors", icon: Users, link: "/dashboard/mentors-and-community/mentorship" },
  { name: "Community", icon: MessageCircle, link: "/dashboard/mentors-and-community/community" },
];

export const adminSidebarCategories = [
  { name: "Home", icon: Briefcase, link: "/dashboard/home" },
  { name: "Users", icon: Users, link: "/dashboard/users" },
  { name: "Mentors", icon: Mentors, link: "/dashboard/mentor" },
  { name: "In Complete Profiles", icon: UserX, link: "/dashboard/incomplete-profiles" },
  { name: "Complains", icon: complains, link: "/dashboard/complains" },
  
  { 
    name: "Virtual Courses", 
    icon: GraduationCap, 
    items: [
      { name: "List Courses", icon: GraduationCap, link: "/dashboard/courses/list" },
      { name: "Create Courses", icon: GraduationCap, link: "/dashboard/courses/create" }
    ] 
  },
  { 
    name: "Community", 
    icon: Community, 
    items: [
      { name: "List Community Management", icon: MessageCircle, link: "/dashboard/groups/list" },
      { name: "Create Community Management", icon: MessageCircle, link: "/dashboard/groups/create" }
    ] 
  },
  { 
    name: "Group Mentoring", 
    icon: Handshake, 
    items: [
      { name: "List Group Mentoring", icon: Handshake, link: "/dashboard/group-mentoring/list" },
      { name: "Create Group Mentoring", icon: Handshake, link: "/dashboard/group-mentoring/create" }
    ] 
  },
  { 
    name: "Reports & Analytics", 
    icon: ReportIcon, 
    items: [
      { name: "Job Automation Report", icon: ReportIcon, link: "/dashboard/reports/job-automation" },
      { name: "AI Literacy Report", icon: ReportIcon, link: "/dashboard/reports/ai-literacy-report" },
      { name: "Gender Report", icon: ReportIcon, link: "/dashboard/reports/gender-report" }
    ] 
  }
];

export const adminSidebarList = [
  { name: "Home", icon: Briefcase, link: "/dashboard/home" },
  { name: "Users", icon: Users, link: "/dashboard/users" },
  { name: "Mentors", icon: Mentors, link: "/dashboard/mentor" },
  { name: "In Complete Profiles", icon: UserX, link: "/dashboard/incomplete-profiles" },
  { name: "Community", icon: Community, link: "/dashboard/mentors-and-community/community" },
  { name: "Group Mentoring", icon: Handshake, link: "/dashboard/group-mentoring/list" },
  { name: "Virtual Courses", icon: GraduationCap, link: "/dashboard/courses/list" },
  { name: "Community Management", icon: MessageCircle, link: "/dashboard/groups/list" },
  { name: "Reports", icon: ReportIcon, link: "/dashboard/reports/job-automation" },
  { name: "Complains", icon: complains, link: "/dashboard/complains" },
];

export const mentorSidebarList = [
  { name: "Home", icon: Briefcase, link: "/dashboard/home" },
  { name: "Bookings Summaries", icon: Mingcutetimeline, link: "/dashboard/bookingsummary" },
  { name: "Bank Details", icon: Mingcutetimeline, link: "/dashboard/account" },
  { name: "Schedule Timings", icon: CalenderSvg, link: "/dashboard/sheduleTimings" },
  { name: "Pricing", icon: CalenderSvg, link: "/dashboard/pricing" },
  { name: "My Mentees", icon: ChatIconOne, link: "/dashboard/chats-with-mentees" },
  { name: "Explore Mentors", icon: Mentors, link: "/dashboard/mentors-and-community/mentorship" },
  { name: "Community", icon: Community, link: "/dashboard/mentors-and-community/community" },
  { name: "Reviews", icon: Star, link: "/dashboard/reviews" },
  { name: "Mentoring Resources", icon: Star, link: "/dashboard/resources" },
  { name: "Profile Settings", icon: Profile, link: "/dashboard/profile-settings" },
];

export const subMenus = {
  "Recommended Careers": [
    { name: "Existing Careers", link: "/dashboard/recommended-careers" },
    { name: "Emerging AI Careers", link: "/dashboard/recommended-careers/ai-recommended-careers" },
  ],
  "My Smart Learning Helper": [
    { name: "My Smart Learning Helper", link: "/dashboard/skills-and-learning/my-smart-learning-helper" },
    { name: "Recommended Courses", link: "/dashboard/skills-and-learning/recommended-courses" },
    { name: "My Courses", link: "/dashboard/skills-and-learning/my-courses" },
    { name: "Learning Grants and Scholarships", link: "/dashboard/skills-and-learning/learning-grants" },
  ],
  "My Upskilling Pathway": [
    { name: "My Upskilling Pathway", link: "/dashboard/skills-and-learning/my-upskilling-pathway" },
    { name: "Configure Pathway", link: "/dashboard/skills-and-learning/upskilling-pathway-config" },
  ],
  "All Courses": [
    { name: "All Courses", link: "/dashboard/skills-and-learning/all-courses?courseTab=ontrack-courses" },
    { name: "OnTrack Careers Courses", link: "/dashboard/skills-and-learning/all-courses?courseTab=ontrack-courses" },
    { name: "Partner Institution Courses", link: "/dashboard/skills-and-learning/all-courses?courseTab=partner-courses" },
  ],
  "Reports": [
    { name: "Job Automation", link: "/dashboard/reports/job-automation" },
    { name: "AI Literacy Report", link: "/dashboard/reports/ai-literacy-report" },
    { name: "Gender Report", link: "/dashboard/reports/gender-report" },
  ],
  "Jobs": [
    { name: "Explore Jobs", link: "/dashboard/job-support/jobs" },
    { name: "Voice Interview Prep", link: "/dashboard/job-support/jobs/voice-interview-prep" },
  ],
  "Mentors": [
    { name: "Explore Mentors", link: "/dashboard/mentors" },
    { name: "Chat with Mentors", link: "/dashboard/chat" },
    { name: "My Appointments", link: "/dashboard/mentors/appointments" },
  ],
  "Community Management": [
    { name: "List Community Management", link: "/dashboard/groups/list" },
    { name: "Create Community Management", link: "/dashboard/groups/create" },
  ],
  "Virtual Courses": [
    { name: "List Courses", link: "/dashboard/courses/list" },
    { name: "Create Courses", link: "/dashboard/courses/create" },
  ],
  "Group Mentoring": [
    { name: "List Group Mentoring", link: "/dashboard/group-mentoring/list" },
    { name: "Create Group Mentoring", link: "/dashboard/group-mentoring/create" },
  ],
}; 
